export default "__VITE_ASSET__3vO26Xg3__"